/* eslint-disable @typescript-eslint/no-explicit-any */
 
 
 
 
 
 
import { create } from 'zustand';
import { GameSaveManager, type GameSave } from '../schemas/gameSave';

interface SaveGameState {
  loading: boolean;
  error: string | null;
  
  // Actions
  getNextSlotId: () => Promise<number>;
  saveGame: (gameState: any, currentSlotId?: number | null) => Promise<{ save: GameSave; slotId: number }>;
  loadGame: (slotId: number) => Promise<GameSave>;
  listSaves: () => Promise<{ id: number; save: GameSave }[]>;
  deleteSave: (slotId: number) => Promise<void>;
  setLoading: (loading: boolean) => void;
  setError: (error: string | null) => void;
}

export const useSaveGameStore = create<SaveGameState>((set, get) => ({
  loading: false,
  error: null,

  setLoading: (loading) => set({ loading }),
  setError: (error) => set({ error }),

  getNextSlotId: async () => {
    const saves = await GameSaveManager.listSaves();
    const usedIds = saves.map(save => save.id);
    let nextId = 1;
    while (usedIds.includes(nextId)) {
      nextId++;
    }
    return nextId;
  },

  saveGame: async (gameState, currentSlotId) => {
    set({ loading: true, error: null });
    try {
      // Use current slot if it exists, otherwise get next available
      const slotId = currentSlotId ?? await get().getNextSlotId();
      
      const save = GameSaveManager.createSave(gameState);
      await GameSaveManager.saveGame(save, slotId);
      
      return { save, slotId }; // Return both the save data and the slot ID
    } catch (err) {
      const message = err instanceof Error ? err.message : 'Failed to save game';
      set({ error: message });
      throw err;
    } finally {
      set({ loading: false });
    }
  },

  loadGame: async (slotId) => {
    set({ loading: true, error: null });
    try {
      const save = await GameSaveManager.loadGame(slotId);
      return save;
    } catch (err) {
      const message = err instanceof Error ? err.message : 'Failed to load game';
      set({ error: message });
      throw err;
    } finally {
      set({ loading: false });
    }
  },

  listSaves: async () => {
    set({ loading: true, error: null });
    try {
      return await GameSaveManager.listSaves();
    } catch (err) {
      const message = err instanceof Error ? err.message : 'Failed to list saves';
      set({ error: message });
      throw err;
    } finally {
      set({ loading: false });
    }
  },

  deleteSave: async (slotId) => {
    set({ loading: true, error: null });
    try {
      await GameSaveManager.deleteSave(slotId);
    } catch (err) {
      const message = err instanceof Error ? err.message : 'Failed to delete save';
      set({ error: message });
      throw err;
    } finally {
      set({ loading: false });
    }
  }
}));